import { useCallback } from 'react';

import * as hooks from './hooks';
import * as pas from '../../pas';
import { useLogout } from '../useLogout';

export const useValidateSession = () => {
    const logout = useLogout();
    const validateTCVersion = hooks.useValidateTCVersion();
    const validatePasswordChange = hooks.useValidatePasswordChange();
    const validate2FA = hooks.useValidate2FA();
    const validateMFA = hooks.useValidateMFA();
    const validatePin = hooks.useValidatePin();
    const validateFitToPlay = hooks.useValidateFitToPlay();

    return useCallback(async (pasLoginResponse, options = {}) => {
        const { sessionValidationData } = pasLoginResponse?.data || {};

        if (!sessionValidationData) {
            return Promise.resolve();
        }

        try {
            await Promise.all([
                validateTCVersion(pasLoginResponse),
                validatePasswordChange(pasLoginResponse),
                validateMFA(pasLoginResponse),
                validate2FA(pasLoginResponse),
                validatePin(pasLoginResponse, options),
                validateFitToPlay(pasLoginResponse, options)
            ]);
        } catch (error) {
            logout({ isQuiet: true });

            throw error;
        }

        const tempTokenResponse = await pas.getTempToken();

        return tempTokenResponse?.data?.sessionToken?.sessionToken;
    }, [
        logout,
        validate2FA,
        validateFitToPlay,
        validateMFA,
        validatePasswordChange,
        validatePin,
        validateTCVersion
    ]);
};
